<template>
  <CustomDeleteDialog
    dialogTitle="حذف فایل"
    :dialogId="`remove-single-resource-attachment-${dialogId}`"
    okTitle="حذف"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendDeleteResourceAttachment"
  >
    <p>آیا از حذف فایل اطمینان دارید؟</p>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    dialogId: {
      type: [String, Number],
    },
    attachmentId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendDeleteResourceAttachment() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let removeResourceAttachmentById = new RemoveResourceAttachmentById(
          _this
        );
        removeResourceAttachmentById.setRequestParam({
          id: _this.attachmentId,
        });

        await removeResourceAttachmentById.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "فایل شما با موفقیت حذف شد.",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide(
              `remove-single-resource-attachment-${this.dialogId}`
            );
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomDeleteDialog,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import { RemoveResourceAttachmentById } from "@/libs/Api/Resources";
</script>
